import { h } from 'preact';
import { useCallback, useState, useRef } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import Image from 'utils/image';
import Video from 'utils/reactVideo';
import Icon from '../utils/icon';
import Zoom from './zoom'; 

const ProductGalleryZoom = ({
  media,
  index,
  enableZoom,
  isMobile,
  enableBlendMode
}) => {
  SwiperCore.use([Pagination, Navigation]);
  // eslint-disable-next-line
  const [vimeoVideo, setVimeoVideo] = useState(null);
  const onPlayerInitialization = 
  useCallback((vimeovideoplayer) => setVimeoVideo(vimeovideoplayer), []);

  const swiperRef = useRef(null);
  const [isZoomed, setIsZoomed] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const handlePrevClick = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
      setIsZoomed(false);
    }
  }

  const handleNextClick = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
      setIsZoomed(false);
    }
  }

  const handleImageClick = (e) => {
    if(!isMobile){
      e.preventDefault();
      const { left, top, width, height } = 
      e.currentTarget.getBoundingClientRect();
      const x = (e.clientX - left) / width;
      const y = (e.clientY - top) / height;
    
      // Set the initial background position here
      const initialBackgroundPositionX = (x * 100).toFixed(2);
      const initialBackgroundPositionY = (y * 100).toFixed(2);
    
      setIsZoomed(!isZoomed);
      setMousePosition(
        { x, 
          y, 
          initialBackgroundPositionX, 
          initialBackgroundPositionY 
        }
      );
    }
  };

  const handleCloseClick = () => {
    enableZoom(null);
  }
  

  return (
    <div className='fixed h-[100svh] w-full top-0 left-0 bg-white z-30 overflow-y-hidden'>
      <div className='relative h-full lg:max-w-[1440px] lg:mx-auto lg:pl-[108px] lg:pr-[108px]'>
        <Swiper 
          slidesPerView={1}
          initialSlide={index}
          pagination={{
            el: "#custom-zoom-pagination",
            type: "bullets",
            bulletClass: "swiper-pagination-bullet custom-zoom-pagination-bullet bg-grey-3 opacity-100",
            bulletActiveClass: "swiper-pagination-bullet-active custom-zoom-pagination-bullet-active bg-charcoal opacity-1",
            clickable: true,
          }}
          loop={true}
          className='w-full h-full'
          onSwiper={(swiper) => {
            swiperRef.current = swiper; 
          }}
          grabCursor={true}
          keyboard={{ enabled: true }}
          data-product-gallery-zoom-slider
        >
          {media?.map((mediaItem) => (
            <SwiperSlide key={mediaItem.id} className='flex items-center min-h-[247px] lg:block'> 
              {mediaItem.media_type === 'image' ?
                <div className={`w-full lg:h-full ${enableBlendMode && 'bg-grey-5'}`} onClick={handleImageClick}>
                   {isZoomed ? (
                    <Zoom 
                      src={mediaItem.src} 
                      isZoomed={isZoomed} 
                      mousePosition={mousePosition} 
                      setMousePosition={setMousePosition}
                    />
                  ) : (
                    <Image
                      {...mediaItem}
                      srcWidths={{ sm: 1280, md: 1536, lg: 2048, xl: 2560, '2x': 3072 }}
                      classes={
                        `w-full h-full 
                         object-contain cursor-zoom-in
                         ${enableBlendMode && 'mix-blend-darken'}
                        `
                      }
                    />
                  )}
                </div>
              : mediaItem.media_type === 'external_video' ? 
                <div className='relative aspect-video w-full'>
                  <Video
                    className="h-full w-full relative z-1"
                    autoplay={true}
                    loop={true}
                    externalId={mediaItem.external_id}
                    id={mediaItem.id}
                    showControls={false}
                    onPlayerInit={onPlayerInitialization}
                  />
                </div>
              : mediaItem.media_type === 'video' ? 
                <div className='relative aspect-video'>
                  <Video
                    className='h-full w-full relative z-1'
                    autoplay={true}
                    loop={true}
                    isHTML5={true}
                    id={media.id}
                    videoSrc={mediaItem.sources[1].url}
                    showControls={false}
                  />
                </div>
							: <Image
							src={mediaItem}
							srcWidths={{ sm: 1280, md: 1536, lg: 2048, xl: 2560, '2x': 3072 }}
							classes={
								`w-full h-full 
								 object-contain cursor-zoom-in
								`
							}
						/>
              }
            </SwiperSlide>
          ))}
        </Swiper>
        <div className='
          custom-zoom-prev-button 
          left-3 cursor-pointer z-10 absolute -translate-y-1/2 top-1/2
          lg:left-7' 
          onClick={handlePrevClick}
        >
          <Icon name='arrow-prev'/>
        </div>
        <div className='
          custom-zoom-next-button 
          right-3 cursor-pointer z-10 absolute -translate-y-1/2 top-1/2
          lg:right-7' 
          onClick={handleNextClick}
        >
          <Icon name='arrow-prev' className='rotate-180' />
        </div>
        <div className='absolute top-[20px] right-[28px] cursor-pointer z-10' onClick={handleCloseClick}>
          <Icon name='close'/>
        </div>
        {isMobile && 
          <p className='absolute bottom-[62px] body-1 text-primary text-center z-10 w-full'>
            {window.TMW.Strings.product.pinchToZoom}
          </p>
        }
        <div id='custom-zoom-pagination' 
          className='absolute left-0 text-center !bottom-10 z-10
            lg:!bottom-8'
        />
      </div>
    </div>
  )
};

export default ProductGalleryZoom;